(function () {
  function selectedItems() {
    var items = [];
    document.querySelectorAll('.ps-addon-card.is-selected[data-variant-id]').forEach(function (card) {
      var id = Number(card.getAttribute('data-variant-id'));
      if (id) items.push({ id: id, quantity: 1 });
    });
    return items;
  }

  window.psGetAddonCartItems = selectedItems;

  function syncSelectedClass(card) {
    if (!card) return;
    card.classList.toggle('addon-selected', card.classList.contains('is-selected'));
  }

  function init(root) {
    if (!root || root.getAttribute('data-ps-addon-ready')) return;
    root.setAttribute('data-ps-addon-ready', '1');

    var track = root.querySelector('[data-ps-addon-track]');
    var seenIds = {};
    root.querySelectorAll('[data-ps-addon-card]').forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (!id) return;
      if (seenIds[id]) {
        card.remove();
        return;
      }
      seenIds[id] = true;
    });

    if (!root.querySelector('[data-ps-addon-pill]')) {
      var labels = {};
      root.querySelectorAll('[data-ps-addon-card]').forEach(function (card) {
        var handles = (card.getAttribute('data-collections') || '').trim().split(/\s+/).filter(Boolean);
        var label = card.getAttribute('data-collection-label') || '';
        handles.forEach(function (handle) {
          if (handle && !labels[handle]) labels[handle] = label || handle;
        });
      });
      var handles = Object.keys(labels);
      if (handles.length) {
        var wrap = document.createElement('div');
        wrap.className = 'ps-addon__pills';
        wrap.setAttribute('role', 'tablist');
        wrap.setAttribute('aria-label', (root.querySelector('.ps-addon__title') || {}).textContent || 'Add-on');
        var allBtn = document.createElement('button');
        allBtn.type = 'button';
        allBtn.className = 'ps-addon__pill is-active';
        allBtn.setAttribute('data-ps-addon-pill', 'all');
        allBtn.setAttribute('role', 'tab');
        allBtn.setAttribute('aria-selected', 'true');
        allBtn.textContent = 'All';
        wrap.appendChild(allBtn);
        handles.forEach(function (handle) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ps-addon__pill';
          btn.setAttribute('data-ps-addon-pill', handle);
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-selected', 'false');
          btn.textContent = labels[handle];
          wrap.appendChild(btn);
        });
        var inner = root.querySelector('.ps-addon__inner');
        var carousel = root.querySelector('.ps-addon__carousel-wrap');
        if (inner && carousel) inner.insertBefore(wrap, carousel);
      }
    }

    var pills = root.querySelectorAll('[data-ps-addon-pill]');
    var modal = root.querySelector('[data-ps-addon-modal]');
    var modalTitle = root.querySelector('[data-ps-addon-modal-title]');
    var modalImage = root.querySelector('[data-ps-addon-modal-image]');
    var activeCard = null;

    function filterCards(handle) {
      root.querySelectorAll('[data-ps-addon-card]').forEach(function (card) {
        var collections = (card.getAttribute('data-collections') || '').trim().split(/\s+/).filter(Boolean);
        var show = handle === 'all' || collections.indexOf(handle) !== -1;
        card.hidden = !show;
        card.classList.toggle('is-filtered-out', !show);
      });
      if (track) track.scrollLeft = 0;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.toggle('is-active', p === pill);
          p.setAttribute('aria-selected', p === pill ? 'true' : 'false');
        });
        filterCards(pill.getAttribute('data-ps-addon-pill'));
      });
    });

    function toggleCard(card) {
      if (!card || card.classList.contains('is-soldout')) return;
      card.classList.toggle('is-selected');
      syncSelectedClass(card);
    }

    function openModal(card) {
      if (!modal || !card) return;
      activeCard = card;
      if (modalTitle) modalTitle.textContent = card.getAttribute('data-title') || '';
      if (modalImage) {
        var src = card.getAttribute('data-image') || '';
        modalImage.src = src;
        modalImage.alt = card.getAttribute('data-title') || '';
        modalImage.hidden = !src;
      }
      modal.hidden = false;
      document.body.classList.add('ps-addon-modal-open');
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      activeCard = null;
      document.body.classList.remove('ps-addon-modal-open');
    }

    root.addEventListener('click', function (e) {
      var info = e.target.closest('[data-ps-addon-info]');
      if (info) {
        e.preventDefault();
        e.stopPropagation();
        openModal(info.closest('[data-ps-addon-card]'));
        return;
      }

      var close = e.target.closest('[data-ps-addon-close]');
      if (close) {
        e.preventDefault();
        closeModal();
        return;
      }

      if (e.target.closest('[data-ps-addon-modal-select]')) {
        e.preventDefault();
        if (activeCard && !activeCard.classList.contains('is-selected')) {
          toggleCard(activeCard);
        } else if (activeCard) {
          activeCard.classList.add('is-selected');
          syncSelectedClass(activeCard);
        }
        closeModal();
        return;
      }

      var card = e.target.closest('[data-ps-addon-card]');
      if (card && !card.classList.contains('is-soldout')) {
        toggleCard(card);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    var prev = root.querySelector('[data-ps-addon-prev]');
    var next = root.querySelector('[data-ps-addon-next]');
    function scrollByDir(dir) {
      if (!track) return;
      var amount = Math.max(track.clientWidth * 0.7, 220);
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
  }

  function initAll() {
    document.querySelectorAll('[data-ps-addon]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ps-addon]');
    if (root) {
      root.removeAttribute('data-ps-addon-ready');
      init(root);
    }
  });
})();
